import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { debounceTime, take, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { DomiciliationService } from 'src/app/core/providers/services/domiciliation/domiciliation.service';

import { ibanValidator } from '../../../validators/iban.validator';
import { BIC_CODES, Numbers } from 'src/app/utils/constants';

@Component({
  selector: 'app-domiciliation',
  templateUrl: './domiciliation.component.html',
  styleUrls: ['./domiciliation.component.scss']
})
export class DomiciliationComponent implements OnInit {

  @Input() FORM_DATA: FormGroup;
  @Input() DATA_CONFIG: any;
  /**
   * @description constructor
   * @params domiciliationSrv
   */
  constructor(
    private domiciliationSrv: DomiciliationService
  ) {
    this.domiciliationSrv = domiciliationSrv;
  }

  iban: string;
  swift: any;
  isSpain = true;
  insureSelected: string;
  finish = new Subject();
  bic: { [key: string]: string } = BIC_CODES;

  /**
   * @description meotodo inicio
   */
  ngOnInit() {
    this.insureSelected = this.DATA_CONFIG.iban.linkFormPath[0];
    this.setValidator();

    this.FORM_DATA.get([this.insureSelected, 'domiciliation', 'iban']).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap((iban: string) => {
          iban.replace(/ /g, '');
          const COUNTRY_IBAN: string = (iban.substring(0, Numbers.number2)).toUpperCase();
          const IBAN_FIELD: AbstractControl = this.FORM_DATA.get([this.insureSelected, 'domiciliation', 'iban']);
          this.iban = null;
          if (COUNTRY_IBAN !== 'ES') {
            this.isSpain = false;
            this.FORM_DATA.get([this.insureSelected, 'domiciliation', 'swift']).setValidators([Validators.required]);
            if (iban.length > Numbers.number15 && typeof (COUNTRY_IBAN) === 'string') {
              const ERRORS: ValidationErrors = IBAN_FIELD.errors;
              let errorsA: ValidationErrors = null;
              let errorE = false;
              if (ERRORS !== null) {
                delete ERRORS.ibanValidator;
                errorE = Object.keys(ERRORS).length === 0;
              }
              if (errorE === true) {
                errorsA = null;
              } else { errorsA = ERRORS; }
              IBAN_FIELD.setErrors(errorsA);
              this.iban = iban;
              const AUX_S: any = this.FORM_DATA.get([this.insureSelected, 'domiciliation', 'swift']).value;
              if (AUX_S !== '') {
                this.getSwift(this.iban);
              }
            }
          } else {
            this.isSpain = true;
            this.iban = iban;
            const AUX_S: any = this.FORM_DATA.get([this.insureSelected, 'domiciliation', 'swift']).value;
            if (AUX_S !== '') {
              this.getSwift(this.iban);
            }
          }
        })
      ).subscribe();
    this.FORM_DATA.get([this.insureSelected, 'domiciliation', 'swift']).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap((swift: string) => {
          if (swift && swift.length > 0) {
            this.getSwift(this.iban);
            if (this.isSpain) {
              this.checkSwiftAndIbanSp();
            }
          }
        })
      ).subscribe();
  }

  /**
   * @description mostrar requeridos
   */
  showRequireds(): void {
    const IBAN_FIELD: AbstractControl = this.FORM_DATA.get([this.insureSelected, 'domiciliation', 'iban']);
    IBAN_FIELD.setValidators([Validators.required]);
    IBAN_FIELD.markAsTouched();
    if (IBAN_FIELD && IBAN_FIELD.value.length === 0) {
      IBAN_FIELD.setErrors({ required: 'form1.default-error' });
    }
  }
  /**
   * @description recuperar codigo swift
   * @params swift
   */
  getSwift(iban: string): void {
    // Si el codigo swift no es valido se muestra el mensaje de error
    this.domiciliationSrv.getSwift(iban)
      .pipe(take(1))
      .subscribe((swiftResp: any) => {
        // this.FORM_DATA.get([this.insureSelected, 'domiciliation', 'swift']).updateValueAndValidity();
        const SWIFT_FIELD: AbstractControl = this.FORM_DATA.get([this.insureSelected, 'domiciliation', 'swift']);
        const SWIFT_FIELD_V: any = SWIFT_FIELD.value;
        if (swiftResp.swift.length > 0) {
          const ERRORS: ValidationErrors = SWIFT_FIELD.errors;
          let errorsA: ValidationErrors = null;
          let errorE = false;
          if (ERRORS !== null) {
            delete ERRORS.invalidSwift;
            errorE = Object.keys(ERRORS).length === 0;
          }
          if (errorE === true) {
            errorsA = null;
          } else { errorsA = ERRORS; }
          if (swiftResp.swift === SWIFT_FIELD_V) {
            SWIFT_FIELD.setErrors(errorsA);
            this.swift = SWIFT_FIELD_V;
            if (this.isSpain) {
              this.checkSwiftAndIbanSp();
            }
          } else {
            SWIFT_FIELD.setErrors({ invalidSwift: true });
          }
        } else {
          if (SWIFT_FIELD_V !== '') {
            SWIFT_FIELD.setErrors({ invalidSwift: true });
          }
        }
      });
  }
  /**
   * @description comprobar codigo swift e IBAN
   */
  checkSwiftAndIbanSp(): void {
    const AUX_SWIFT_VALUE: any = this.FORM_DATA.get([this.insureSelected, 'domiciliation', 'swift']).value;
    const AUX_SWIFT_FIELD: AbstractControl = this.FORM_DATA.get([this.insureSelected, 'domiciliation', 'swift']);
    if (this.iban && (AUX_SWIFT_VALUE !== '' && AUX_SWIFT_VALUE.length >= Numbers.number11)) {
      const AUX_ENTITY: string = this.iban.substring(Numbers.number4, Numbers.number8);
      const AUX_BIC: string = this.calculoBic(AUX_ENTITY);
      const ERRORS: ValidationErrors = AUX_SWIFT_FIELD.errors;
      let errorsA: ValidationErrors = null;
      let errorE = false;
      if (ERRORS !== null) {
        delete ERRORS.invalidSwift;
        errorE = Object.keys(ERRORS).length === 0;
      }
      if (errorE === true) {
        errorsA = null;
      } else { errorsA = ERRORS; }

      if (AUX_SWIFT_VALUE === AUX_BIC) {
        AUX_SWIFT_FIELD.setErrors(errorsA);
        this.swift = AUX_SWIFT_VALUE;
        if (this.isSpain) {
        }
      } else {
        AUX_SWIFT_FIELD.setErrors({ invalidSwift: true });
      }
    }
  }
  /**
   * @description calcular BIC
   * @params entidad
   */
  calculoBic(entidad: any): string {
    const AUX_ENTITY_N = entidad * 1;
    const AUX_ENTITY = 'bic-' + AUX_ENTITY_N;
    const RESP_BIC: string = this.bic[AUX_ENTITY];
    let rBic = '';
    if (RESP_BIC !== '') { rBic = RESP_BIC; }
    return rBic;
  }

  /**
   * @description asignar las validaciones del paso
   */
  public setValidator(): void {
    this.FORM_DATA.get([this.insureSelected, 'domiciliation', 'iban']).setValidators([ibanValidator(), Validators.required]);
    this.FORM_DATA.get([this.insureSelected, 'domiciliation', 'iban']).updateValueAndValidity();
  }
}
